export const mavigpsSVG = './assets/logos/mavigps.svg';

export const usersSvg = './assets/icons/account-group.svg';
export const stockSVG = './assets/icons/cars.svg';
export const settingSVG = './assets/icons/settings.svg';
export const dashboarSVG = './assets/icons/mavigps-dashboard.svg';
export const dashboardFilledSVG = './assets/icons/dashboard-24px.svg';
export const logoutSVG = './assets/icons/logout.svg';
export const flagSVG = './assets/icons/flag-line.svg';
export const traceSVG = './assets/icons/last_travel.svg';
export const simCardSVG = './assets/icons/sim.svg';
export const deviceSvg = './assets/icons/cassette.svg';
export const webConfigurationSVG = './assets/icons/format-color-fill.svg';

export const gpsOnSVG = './assets/icons/gpsOn.svg';
export const angleLeftSVG = './assets/icons-bkp/angle-line-left.svg';
export const angleRightSVG = "./assets/icons-bkp/angle-line-rigth.svg";
export const angleDownSVG = './assets/icons-bkp/angle-down-line.svg';
export const angleUpSVG = './assets/icons-bkp/angle-up-line.svg';
export const errorCircleSVG = './assets/icons/times-circle-line.svg';
export const checkCircleSVG = './assets/icons/check-circle-line.svg';
export const uploadSVG = './assets/icons/upload-line.svg';
export const userSVG = './assets/icons/user.svg';
export const editSVG = './assets/icons/edit.svg';
export const infoSVG = './assets/icons//information-variant.svg';
export const visitPlaceSVG = './assets/icons/visit_place.svg';
export const carSVG = './assets/icons/car.svg';
export const closeSvg = './assets/icons/delete.svg';
export const ticketsSVG = './assets/icons/clipboard-solid.svg';
export const commentSVG = './assets/icons/talk-bubbles-line.svg';
export const historySVG = './assets/icons/history-line.svg';
export const checkSVG = './assets/icons/check.svg';
export const cancelSVG = './assets/icons/close.svg';
export const officeBuildingSVG = "./assets/icons/office-building.svg";
export const verificationSVG = "./assets/icons/checkbox-marked-circle-outline.svg";
export const fullscreenSVG = "./assets/icons/fullscreen.svg";
export const exitFullScreenSVG = "./assets/icons/fullscreen-exit.svg";
export const plusSVG = "./assets/icons/plus.svg";
export const infoVersionSVG = "./assets/icons/info.svg";
export const installationSVG = "./assets/icons/installation.svg";
export const manteinanceSVG = "./assets/icons/manteinance.svg";
export const unintallSVG = "./assets/icons/unintall.svg";
export const eyeSVG = "./assets/icons/ojo.svg";

//Image Background
export const coworkerSVG = './assets/images/coworker.svg';
export const factoryBackgroundSVG = "./assets/images/factory.svg";
export const ticketsProcessBackgroundSVG = "./assets/images/tickets.svg";
export const contactBackgroundSVG = "./assets/images/contact.svg";
export const usersBackgroundSVG = "./assets/images/users.svg";
export const famaleSVG = "./assets/images/female.svg";
export const maleSVG = "./assets/images/male.svg";
export const peopleSVG = "./assets/images/people.svg";
export const warningSVG = "./assets/images/warning.svg";
export const notFount404PNG = "./assets/images/not_found.png";
export const fastCarSVG = "./assets/images/fast_car.svg";
export const uploadImageSVG = "./assets/images/image_upload.svg"




